import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	lineHeight,
	TextButton,
} from '@calm-web/design-system';

import lockIcon from 'icons/lock-outline.svg';

export const Wrapper = styled.li<{
	isAvailable: boolean;
}>`
	align-items: center;
	cursor: ${p => (p.isAvailable ? 'cursor' : 'pointer')};
	display: flex;
	opacity: ${p => (p.isAvailable ? '1' : '0.8')};
	margin: 0 auto;
	padding: 16px 0 24px;
	pointer-events: ${p => (p.isAvailable ? 'auto' : 'none')};
	max-width: 480px;
	z-index: 0;
`;

export const ClickableWrapper = styled(TextButton).attrs({
	textColor: 'white',
})`
	text-decoration: none;
	flex: 1;
`;

export const GuidePosition = styled.svg<{
	$isCompleted: boolean;
}>`
	flex: 0 0 16px;
	height: 16px;
	margin-right: 8px;
	position: relative;
	top: 2px;
	width: 16px;

	& path {
		fill: ${p => (p.$isCompleted ? palette('accessibleBrandGradient') : palette('white'))};
	}
`;

export const Title = styled.div<{
	isCourse: boolean;
}>`
	align-items: center;
	color: ${palette('white')};
	${fontSize(FontSizes.base)};
	${lineHeight(FontSizes.base)};
	${fontWeight(FontWeights.Medium)};
	display: flex;
	text-align: left;
	width: 100%;
`;

export const Duration = styled.div`
	font-size: 13.5px;
	font-weight: 700;
	text-align: left;
`;

export const LockIcon = styled(lockIcon)`
	flex: 0 0 24px;
	height: 24px;
	position: relative;
	width: 24px;
	z-index: 5;

	& path {
		fill: ${palette('white')};
	}
`;

export const FaveHeartContainer = styled.div`
	width: 24px;
`;
